import { TbCircleCheck, TbCircleX, TbClockPause } from 'react-icons/tb';
import { ApprovalStatusEnum, PaymentStatusEnum } from 'types';

export default function PostDetailStatusComp({
    status,
    rejectReason,
    paymentStatus,
}: {
    status?: ApprovalStatusEnum;
    rejectReason?: string;
    paymentStatus?: PaymentStatusEnum;
}) {
    return (
        <div className="mb-4">
            <p className="t-400 t-p1 t-l-black1 mb-1">وضعیت آگهی</p>
            {paymentStatus === PaymentStatusEnum.pending || paymentStatus === PaymentStatusEnum.failed ? (
                <p>
                    <TbClockPause size={16} className="t-yellow ml-1" />
                    آگهی شما در وضعیت <span className="t-yellow">در انتظار پرداخت</span> است و پس از پرداخت و تایید
                    مدیریت در لیست آگهی‌های تیک سبز منتشر خواهد شد.
                </p>
            ) : status === ApprovalStatusEnum.approved ? (
                <p>
                    <TbCircleCheck size={16} className="t-green ml-1" />
                    آگهی شما در وضعیت <span className="t-green">منتشر شده</span> است و در لیست آگهی‌های تیک سبز قرار
                    دارد
                </p>
            ) : status === ApprovalStatusEnum.pending ? (
                <p>
                    <TbClockPause size={16} className="t-yellow ml-1" />
                    آگهی شما در وضعیت <span className="t-yellow">در انتظار تایید</span> است و پس از تایید مدیریت در لیست
                    آگهی‌های تیک سبز منتشر خواهد شد.
                </p>
            ) : status === ApprovalStatusEnum.rejected ? (
                <div>
                    <p>
                        <TbCircleX size={16} className="t-red ml-1" />
                        آگهی شما پس از بررسی مدیریت در وضعیت <span className="t-red">رد شده</span> قرار گرفته است. دلیل
                        رد شدن این آگهی به شرح زیر است:{' '}
                    </p>
                    <p
                        className="mt-1 t-red-i"
                        dangerouslySetInnerHTML={rejectReason ? { __html: rejectReason } : undefined}
                    />
                </div>
            ) : null}
        </div>
    );
}
